import React, { useEffect, useState } from 'react'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import AssessmentCard from 'components/Mobile/WorkListView/AssessmentCard'
import AsterCircularProgress from 'asterX-UI/Loaders/AsterCircularProgress'

const WlAssessmentsTab = () => {
  const { workListViewStore, workListViewStoreFunc } = useWorkListViewMnStore()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    getWlAssessments()
  }, [])
  const getWlAssessments = async () => {
    setLoading(true)
    await workListViewStoreFunc.getWlAssessments()
    setLoading(false)
  }
  return (
    <div
      style={{
        padding: 16,
        dispplay: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        height: '100%'
      }}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1,
            left: '40%',
            top: '45%'
          }}
        >
          <AsterCircularProgress />
        </div>
      )}
      {workListViewStore?.wlAssessments?.map((item, index) => (
        <AssessmentCard assessment={item} key={index} />
      ))}
    </div>
  )
}
export default WlAssessmentsTab
